<div class="usan-form-item instructions-container">
    <div class="instructions-text">
        Use this form to request revisions to a published adoption statement.  Please attach a copy of the adoption statement, if available. 
        Please take note of the following when submitting this application:
        <div>
            <ol>  
                <li>For requests to change the molecular formula, molecular weight, or structural formula, attach documentation of new chemical information for this compound.</li>
                <li>For requests to change the CAS Registry Number, attach documentation that CAS has changed it.</li>
                <li>For requests to change manufacturer or other supporting information, please provide documentation detailing these changes.</li>
            </ol>
        </div>
    </div>
  </div>